import { getNodeLink } from '@livv/utils/helpers';
import { ListItem, SxProps } from '@mui/material';
import { FC } from 'react';
import { PlainLink } from '@components/Links';

interface ParentNodeProps {
    bookId: string;
    bookPath: string;
    id: string;
    parentPath?: string[];
    title: string;
}

const parentSx: SxProps = {
    display: 'inline-block',
    my: 1,
};

const ParentNode: FC<ParentNodeProps> = ({ bookId, bookPath, id, parentPath, title }) => {
    const nodeLink = getNodeLink({
        bookId,
        bookPath: parentPath ? `${bookPath.split('/').slice(0, -1).join('/')}/${id}` : id,
    });

    return (
        <ListItem key={id} sx={{ listStyleType: 'disc' }} disablePadding>
            <PlainLink
                href={nodeLink}
                sx={{ ...parentSx, color: 'text.secondary', display: 'list-item' }}
                underline="hover"
            >
                {title}
            </PlainLink>
        </ListItem>
    );
};

export default ParentNode;
